import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Mount once inside <BrowserRouter>. On every pathname change it resets
 * the window scroll to the top, mirroring native browser behaviour for
 * cross-document navigation. Without this, SPA route changes inherit
 * the previous page's scroll position — which is why clicking a link
 * was landing the user at the footer.
 *
 * Hash links (`/page#section`) are deliberately exempt so anchor jumps
 * still work.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    // `auto` rather than `smooth` — feels instantaneous on link click,
    // matching daft.ie / myhome.ie's native behaviour.
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);
  return null;
};

export default ScrollToTop;
